import axios from 'axios'
import cookies from '@/libs/util.cookies'
import { get } from 'lodash'
import qs from 'qs'

var baseURL = process.env.VUE_APP_API
function createService() {
    // 创建一个 axios 实例
    const service = axios.create({
        baseURL: baseURL,
        timeout: 20000,
        paramsSerializer: (params) => qs.stringify(params, { indices: false })
    })
    // 请求拦截
    service.interceptors.request.use(
        config => config,
        error => {
            // 发送失败
            console.log(error)
            return Promise.reject(error)
        }
    )
    // 响应拦截
    service.interceptors.response.use(
        async response => {
            // dataAxios 是 axios 返回数据中的 data
            let dataAxios = response.data || null
            if (response.headers['content-disposition']) {
                dataAxios = response
            }
            // 这个状态码是和后端约定的
            const { code } = dataAxios
            // 根据 code 进行判断
            if (code === undefined) {
                // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
                return dataAxios
            } else {
                // 有 code 代表这是一个后端接口 可以进行进一步的判断
                switch (code) {
                    case 2000:
                        // [ 示例 ] code === 2000 代表没有错误
                        // TODO 可能结果还需要code和msg进行后续处理，所以去掉.data返回全部结果
                        // return dataAxios.data
                        return dataAxios
                    case 401:
                        if (response.config.url === 'api/login/') {
                            errorCreate(`${getErrorMessage(dataAxios.msg)}`)
                            break
                        }
                        var res = await refreshTken()
                        // 设置请求超时次数
                        var config = response.config
                        cookies.set('uuid', res.data.access)
                        config.headers.Authorization = 'JWT ' + res.data.access
                        config.__retryCount = config.__retryCount || 0
                        if (config.__retryCount >= config.retry) {
                            // 如果重试次数超过3次则跳转登录页面
                            cookies.remove('uuid')
                            router.push({ path: '/login' })
                            errorCreate('认证已失效,请重新登录~')
                            break
                        }
                        config.__retryCount += 1
                        return service(config)
                    case 404:
                        dataNotFound(`${dataAxios.msg}`)
                        break
                    case 4000:
                        // 删除cookie
                        errorCreate(`${getErrorMessage(dataAxios.msg)}`)
                        break
                    case 400:
                        // errorCreate(`${dataAxios.msg}`)
                        return dataAxios
                        break
                    default:
                        // 不是正确的 code
                        errorCreate(`${dataAxios.msg}: ${response.config.url}`)
                        break
                }
            }
        },
        error => {
            const status = get(error, 'response.status')
            switch (status) {
                case 400:
                    error.message = '请求错误'
                    break
                case 401:
                    cookies.remove('token')
                    cookies.remove('uuid')
                    cookies.remove('refresh')
                    router.push({ path: '/login' })
                    error.message = '认证已失效,请重新登录~'
                    break
                case 403:
                    error.message = '拒绝访问'
                    break
                case 404:
                    error.message = `请求地址出错: ${error.response.config.url}`
                    break
                case 408:
                    error.message = '请求超时'
                    break
                case 500:
                    error.message = '服务器内部错误'
                    break
                case 501:
                    error.message = '服务未实现'
                    break
                case 502:
                    error.message = '网关错误'
                    break
                case 503:
                    error.message = '服务不可用'
                    break
                case 504:
                    error.message = '网关超时'
                    break
                case 505:
                    error.message = 'HTTP版本不受支持'
                    break
                default:
                    break
            }
            console.error(error)
            return Promise.reject(error)
        }
    )
    return service
}

/**
* @description 创建请求方法
* @param {Object} service axios 实例
*/
function createRequestFunction(service) {
    // 校验是否为租户模式。租户模式把域名替换成 域名 加端口
    return function (config) {
        const uuid = cookies.get('uuid')
        // 进行布尔值兼容
        var params = get(config, 'params', {})
        for (const key of Object.keys(params)) {
            if (String(params[key]) === 'true') {
                params[key] = 1
            }
            if (String(params[key]) === 'false') {
                params[key] = 0
            }
        }
        const configDefault = {
            headers: {
                Authorization: uuid,
                'Content-Type': get(config, 'headers.Content-Type', 'application/json')
            },
            timeout: 60000,
            baseURL: baseURL,
            data: {},
            params: params,
            retry: 3, // 重新请求次数
            retryDelay: 1000 // 重新请求间隔
        }
        return service(Object.assign(configDefault, config))
    }
}

export const service = createService()
export const request = createRequestFunction(service)

// 刷新token
const refreshTken = function () {
    const refresh = cookies.get('refresh')
    return request({
        url: 'token/refresh/',
        method: 'post',
        data: {
            refresh: refresh
        }
    })
}

/**
 * @description 创建一个错误
 * @param {String} msg 错误信息
 */
export function errorCreate(msg) {
    const error = new Error(msg)
    console.error(error)
    throw error
}

